var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hideTitle ? _c("p", [_vm._v(_vm._s(_vm.drug.title))]) : _vm._e(),
    _vm._v(" "),
    +_vm.drug.pack_set !== 1
      ? _c("p", [
          _vm._v("Комплект: "),
          _c("strong", [_vm._v(_vm._s(+_vm.drug.pack_set))]),
          _vm._v(" з.у."),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.drug.pack_comment || _vm.drug.pack_box_comment
      ? _c("div", { staticClass: "alert alert-info" }, [
          _vm.drug.pack_comment
            ? _c("p", [_vm._v(_vm._s(_vm.drug.pack_comment))])
            : _vm._e(),
          _vm._v(" "),
          _vm.drug.pack_box_comment
            ? _c("p", [_vm._v(_vm._s(_vm.drug.pack_box_comment))])
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.hideRemain
      ? _c("p", [
          _vm._v("Доступный остаток на складе: "),
          _c("strong", [_vm._v(_vm._s(_vm.drug.remain || 0))]),
          _vm._v(" з.у."),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticClass: "form-group", staticStyle: { "flex-grow": "0" } },
        [
          _c(
            "p",
            [
              +_vm.drug.pack_set !== 1
                ? [
                    _vm._v("\n          Комплектов: "),
                    _c("strong", [_vm._v(_vm._s(_vm.calculatedPackSet))]),
                  ]
                : _vm._e(),
              _vm._v(" \n      "),
            ],
            2
          ),
          _vm._v(" "),
          _c("label", { attrs: { for: "" } }, [_vm._v("Количество (з.у.)")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newData.new_qty,
                expression: "newData.new_qty",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "number", placeholder: "новое количество" },
            domProps: { value: _vm.newData.new_qty },
            on: {
              keyup: _vm.updatePackSet,
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newData, "new_qty", $event.target.value)
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group", staticStyle: { "flex-grow": "1" } },
        [
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newData.comment,
                expression: "newData.comment",
              },
            ],
            staticClass: "form-control",
            attrs: { placeholder: "причина изменения", type: "text" },
            domProps: { value: _vm.newData.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.newData, "comment", $event.target.value)
              },
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }